import { Box, ColorOptions, Image, Spacer, Text, useWindowDimensions } from '@jfs/ui-new'
import { useNavigation } from '@react-navigation/core'
import { colors } from '../../util/colors'
import useFontSize from '../../util/useFontSize'
import usePadding from '../../util/usePadding'
import { isMobileWidth } from '../../util/util'

interface Props {
  isTab: boolean
  isMobile: boolean
}

const ManageVoiceBox = ({ hide }) => {
  const screenWidth = useWindowDimensions()
  const isMobile = isMobileWidth(screenWidth)
  const resPadding = usePadding()
  const { headerSize, textSize } = useFontSize()
  const rightArrow = require('../../assets/images/arrow-right-blue.png')
  const jiobizzVoiceBox = require('../../assets/images/jiobizz-voicebox.png')
  const { navigate } = useNavigation()
  if (hide) {
    return null
  }
  const onKnowmorePress = () => {
    navigate('jio-pay-business')
  }

  return (
    <Box
      flexDirection={isMobile ? 'column-reverse' : 'row'}
      justify={'space-between'}
      marginTop={isMobile ? 24 : -80}
      mb={isMobile ? 80 : 180}
      ph={resPadding}>
      <Box f={isMobile ? undefined : 1} justify={'center'} mt={isMobile ? 24 : undefined}>
        <Box w={isMobile ? undefined : '95%'}>
          <Text
            title={'Manage your VoiceBox using JioPay Business App'}
            fontFamily={'jiotype-black'}
            fontSize={headerSize}
            color={'BLACK_21'}
            lineHeight={isMobile ? 46 : 72}
          />
        </Box>
        <Spacer size={isMobile ? 16 : 32} />
        <Box w={isMobile ? undefined : '80%'}>
          <Text>
            <Text
              title={'Accept payments, view transactions and issue refunds with just a few clicks. '}
              fontFamily={'jiotype-medium'}
              fontSize={textSize}
              lineHeight={isMobile ? 20 : 28}
              color={'BLACK_21'}
              opacity={0.9}
            />
            <Box flexDirection={'row'} align={'center'} onPress={onKnowmorePress} underlayColor={'TRANSPARENT'}>
              <Text
                title={'Know More'}
                color={colors.HIGHLIGHT as ColorOptions}
                fontFamily={'jiotype-medium'}
                fontSize={textSize}
              />
              <Box pt={2} pl={8}>
                <Image source={rightArrow} height={24} width={24} resizeMode="contain" />
              </Box>
            </Box>
          </Text>
        </Box>
        <Spacer size={isMobile ? 32 : 40} />
        <Box flexDirection={'row'} align={'center'}>
          <Box>
            <Image
              source={require('../../assets/images/google-play.png')}
              resizeMode={'contain'}
              width={isMobile ? 132 : 164}
              height={isMobile ? 40 : 48}
            />
          </Box>
        </Box>
      </Box>
      <Box f={isMobile ? undefined : 1} align={'flex-end'}>
        <Image source={jiobizzVoiceBox} height={isMobile ? 258 : 450} width={isMobile ? 300 : 450} resizeMode="cover" />
      </Box>
    </Box>
  )
}

export { ManageVoiceBox }
